import { UPDATE_PAYMENT_STATUS } from "../../../middleware/paymentSignalRMiddleware";
import { FETCHED_PAUSED_SUBSCRIPTION, RESUME_SUBSCRIPTION, RESUME_SUBSCRIPTION_GET_FULL_TOKEN, RESUME_SUBSCRIPTION_RESET_FETCHED_FULL_TOKEN } from "./actions";

export interface ResumeSubscription {
  pricingPlan: string;
  price?: number;
  currencySymbol?: string;
  pausedDate: string;
  billingDate: string;
  isPaid: boolean;
  passedBillingDate: boolean;
}

interface ResumeSubscriptionState {
  loading: boolean;
  errors: any;
  resumeComplete?: boolean;
  resuming?: boolean;
  fetchedFullToken: boolean;
  subscription: ResumeSubscription | null;
  requiresPaymentMethodUpdate: boolean;
  message: string | null;
  stripeBillingPortalUrl?: string | null;
}

const defaultState: ResumeSubscriptionState = {
  loading: true,
  subscription: null,
  errors: null,
  resumeComplete: false,
  resuming: false,
  fetchedFullToken: false,
  requiresPaymentMethodUpdate: false,
  message: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCHED_PAUSED_SUBSCRIPTION + "_PENDING": {
      return {
        ...state,
        resumeComplete: false,
        loading: true,
        errors: null,
        message: null
      };
    }

    case FETCHED_PAUSED_SUBSCRIPTION + "_FULFILLED": {
      return {
        ...state,
        loading: false,
        subscription: action.payload.data
      };
    }

    case FETCHED_PAUSED_SUBSCRIPTION + "_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors,
      };
    }

    case RESUME_SUBSCRIPTION + "_PENDING": {
      return {
        ...state,
        resuming: true,
        resumeComplete: false,
        errors: null
      };
    }

    case RESUME_SUBSCRIPTION + "_FULFILLED": {
      debugger;
      return {
        ...state,
        requiresPaymentMethodUpdate: action.payload.data.requiresPaymentMethodUpdate,
        message: action.payload.data.message
      };
    }

    case RESUME_SUBSCRIPTION + "_REJECTED": {
      debugger;
      return {
        ...state,
        errors: action.payload.response.data.errors,
        requiresPaymentMethodUpdate: action.payload.response.data.requiresPaymentMethodUpdate,
        stripeBillingPortalUrl: action.payload.response.data.stripeBillingPortalUrl,
        message: action.payload.response.data.message,
        resumeComplete: false,
        resuming: false
      };
    }

    case RESUME_SUBSCRIPTION_GET_FULL_TOKEN + "_PENDING": {
      return {
        ...state,
        errors: null,
        resumeComplete: false,
        fetchedFullToken: false
      };
    }

    case RESUME_SUBSCRIPTION_GET_FULL_TOKEN + "_FULFILLED": {
      // this is also called from signalR middleware to log user in after resuming subscription
      return {
        ...state,
        fetchedFullToken: true
      };
    }

    case RESUME_SUBSCRIPTION_GET_FULL_TOKEN + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors
      };
    }

    case UPDATE_PAYMENT_STATUS: {
      return {
        ...state,
        resumeComplete: action.meta.paymentStatus === 100,
        resuming: false
      };
    }

    case RESUME_SUBSCRIPTION_RESET_FETCHED_FULL_TOKEN: {
      return {
        ...state,
        fetchedFullToken: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
